import React from 'react';

import Container from '../../interface/Container';
import { CircleCtaButton } from '../HeaderMastheadHalfImage/HeaderMastheadHalfImage.styles';
import { Title, Subtitle, Wrapper } from './HeaderMastheadBasic.styles';

const HeaderMastheadBasic = ({ headerData }) => {
  const { title, subTitle, linkTitle, ctaUrl } = headerData;

  return (
    <Wrapper>
      <Container size="small">
        {subTitle && <Subtitle>{subTitle}</Subtitle>}
        <Title>{title}</Title>
      </Container>
      {linkTitle && ctaUrl && (
        <CircleCtaButton href={ctaUrl.url} type={ctaUrl.type}>
          {linkTitle}
        </CircleCtaButton>
      )}
    </Wrapper>
  );
};

export default HeaderMastheadBasic;
